import { api, apiClient } from './client'
import type {
  CalculateMarginRequest,
  ClosePositionRequest,
  ClosePositionResult,
  CreatePositionRequest,
  DataEnvelope,
  MarginPreview,
  Paginated,
  Position,
  PositionStatus,
  UpdatePendingRequest,
  UpdateProtectionRequest,
} from './types'

/**
 * Client positions — API_DOCUMENTATION §5.6–5.13.
 * Write endpoints require `trade:full`; read endpoints accept `trade:read`.
 */
export const positionsApi = {
  list: (params?: { status?: PositionStatus; page?: number }) =>
    api.get<Paginated<Position>>('/client/positions', params),

  show: (id: number) =>
    api.get<DataEnvelope<Position>>(`/client/positions/${id}`),

  calculateMargin: (body: CalculateMarginRequest) =>
    api.post<DataEnvelope<MarginPreview>>(
      '/client/positions/calculate/margin',
      body,
    ),

  create: (body: CreatePositionRequest) =>
    api.post<DataEnvelope<Position>>('/client/positions', body),

  updateProtection: (id: number, body: UpdateProtectionRequest) =>
    api.patch<DataEnvelope<Position>>(
      `/client/positions/${id}/protection`,
      body,
    ),

  updatePending: (id: number, body: UpdatePendingRequest) =>
    api.patch<DataEnvelope<Position>>(
      `/client/positions/${id}/pending`,
      body,
    ),

  close: (id: number, body: ClosePositionRequest) =>
    api.post<DataEnvelope<ClosePositionResult>>(
      `/client/positions/${id}/close`,
      body,
    ),

  /** Cancel pending — 204 No Content */
  destroy: async (id: number): Promise<void> => {
    await apiClient.delete(`/client/positions/${id}`)
  },
}
